export default {
    loading: "Cargando...",
    loaded: "Toque en cualquier lugar para continuar"
}